import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
} from '@mui/material';
import { vortxColors } from '@vortx/shared-ui';

const LAYERS = [
  { key: 'unmanaged', label: 'Unmanaged' },
  { key: 'default', label: 'Default Flux' },
  { key: 'site_tuned', label: 'Site-Tuned' },
  { key: 'tuned_prediction', label: 'Site-Tuned + Prediction' },
];

const fmtCost = (v) => `$${Math.round(v).toLocaleString()}`;
const fmtPeak = (v) => `${Math.round(v).toLocaleString()} kW`;
const fmtPop = (v) => `${v.toFixed(1)}%`;

export default function ResultsSummary({ results }) {
  if (!results) return null;

  const getCellSx = (layerIdx, field) => {
    if (layerIdx === 0) return { color: vortxColors.white };
    const prevKey = LAYERS[layerIdx - 1].key;
    const currKey = LAYERS[layerIdx].key;
    const prev = results[prevKey]?.[field];
    const curr = results[currKey]?.[field];
    if (prev != null && curr != null && curr < prev) {
      return { color: vortxColors.gold, fontWeight: 600 };
    }
    return { color: vortxColors.white };
  };

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ mt: 2, bgcolor: 'transparent', borderColor: vortxColors.stone + '40' }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: vortxColors.gold + '15' }}>
            <TableCell sx={{ fontWeight: 700, color: vortxColors.gold, borderBottom: `1px solid ${vortxColors.stone}40` }}>Layer</TableCell>
            <TableCell align="right" sx={{ fontWeight: 700, color: vortxColors.gold, borderBottom: `1px solid ${vortxColors.stone}40` }}>Total Cost ($)</TableCell>
            <TableCell align="right" sx={{ fontWeight: 700, color: vortxColors.gold, borderBottom: `1px solid ${vortxColors.stone}40` }}>Peak (kW)</TableCell>
            <TableCell align="right" sx={{ fontWeight: 700, color: vortxColors.gold, borderBottom: `1px solid ${vortxColors.stone}40` }}>Energy Cost ($)</TableCell>
            <TableCell align="right" sx={{ fontWeight: 700, color: vortxColors.gold, borderBottom: `1px solid ${vortxColors.stone}40` }}>Demand Cost ($)</TableCell>
            <TableCell align="right" sx={{ fontWeight: 700, color: vortxColors.gold, borderBottom: `1px solid ${vortxColors.stone}40` }}>PoP (%)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {LAYERS.map((layer, idx) => {
            const row = results[layer.key];
            if (!row) return null;
            return (
              <TableRow key={layer.key} sx={{ '&:hover': { bgcolor: vortxColors.gold + '08' } }}>
                <TableCell sx={{ fontWeight: 600, color: vortxColors.white, borderBottom: `1px solid ${vortxColors.stone}20` }}>{layer.label}</TableCell>
                <TableCell align="right" sx={{ ...getCellSx(idx, 'total_cost'), borderBottom: `1px solid ${vortxColors.stone}20` }}>{fmtCost(row.total_cost)}</TableCell>
                <TableCell align="right" sx={{ ...getCellSx(idx, 'peak_kw'), borderBottom: `1px solid ${vortxColors.stone}20` }}>{fmtPeak(row.peak_kw)}</TableCell>
                <TableCell align="right" sx={{ ...getCellSx(idx, 'energy_cost'), borderBottom: `1px solid ${vortxColors.stone}20` }}>{fmtCost(row.energy_cost)}</TableCell>
                <TableCell align="right" sx={{ ...getCellSx(idx, 'demand_cost'), borderBottom: `1px solid ${vortxColors.stone}20` }}>{fmtCost(row.demand_cost)}</TableCell>
                <TableCell align="right" sx={{ ...getCellSx(idx, 'pop_pct'), borderBottom: `1px solid ${vortxColors.stone}20` }}>{fmtPop(row.pop_pct)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
